export default "__VITE_ASSET__DGWCjz5H__"